"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
function Layout(_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)(StyledContainer, { children: children });
}
exports.default = Layout;
var StyledContainer = (0, system_1.styled)(system_1.Box)({
    background: "#FFFFFF",
    boxShadow: "0px 10px 100px rgba(85, 94, 104, 0.1)",
    borderRadius: 30,
    minHeight: 200,
    padding: 22,
    gap: 20,
    minWidth: 400,
});
